import React from 'react';
import { Typography, Box, Paper } from '@mui/material';

function OverallComment({ comment, variant = 'desktop' }) {
  const isMobile = variant === 'mobile';

  // Desktop-specific SVG pointer
  const DesktopPointer = () => (
    <Box sx={{
      position: 'absolute',
      top: '-65px', // 70px height - 5px overlap for the border
      left: '50%',
      transform: 'translateX(-50%)',
      width: '40px',
      height: '70px',
      zIndex: 2, // Ensure pointer is on top of the bubble's border
    }}>
      <svg width="40" height="70" viewBox="0 0 40 70" style={{ display: 'block' }}>
        <defs>
          <clipPath id="speech-bubble-pointer-clip">
            <polygon points="20,0 0,70 40,70" />
          </clipPath>
        </defs>
        {/* The fill for the pointer */}
        <polygon points="20,0 0,70 40,70" fill="#F7F4EF" />
        {/* A path with a 10px stroke, clipped to create a 5px inner border */}
        <path
          d="M 0 70 L 20 0 L 40 70"
          fill="none"
          stroke="#522A27"
          strokeWidth="10"
          clipPath="url(#speech-bubble-pointer-clip)"
          strokeLinejoin="miter"
        />
      </svg>
    </Box>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      {!isMobile && <DesktopPointer />}

      <Paper
          elevation={0}
          sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              backgroundColor: '#F7F4EF', // Conditional border width
              border: isMobile ? '4px solid #522A27' : '5px solid #522A27',
              position: 'relative',
              width: '100%',
              boxSizing: 'border-box',
              zIndex: 1,
              // Mobile-specific pointer using CSS pseudo-elements
              // This uses the "rotated square" technique for a perfect, glitch-free border
              ...(isMobile && {
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  width: '20px',
                  height: '20px',
                  backgroundColor: '#F7F4EF',
                  // Apply border only to the sides that will form the outer edge of the triangle
                  borderBottom: '4px solid #522A27',
                  borderLeft: '4px solid #522A27',
                  // Position and rotate the square into a diamond/triangle pointer
                  bottom: '20px',
                  left: '-13px',
                  transform: 'rotate(45deg)',
                }
              })
          }}
      >
        <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 500 }}>
          {comment}
        </Typography>
      </Paper>
    </Box>
  );
}

export default OverallComment;
